(() => {
  if (customElements.get('flooring-calculator')) return;
  const NF = (o) => new Intl.NumberFormat('es-ES', o);
  const parse = value => {
    let normalized = String(value || '').trim();
    const dotCount = (normalized.match(/\./g) || []).length;

    if (normalized.includes(',')) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else if (dotCount > 1 || /^[-+]?\d+\.\d{3}$/.test(normalized)) {
      normalized = normalized.replace(/\./g, '');
    }

    const number = Number(normalized);
    return Number.isFinite(number) ? number : NaN;
  };
  const cur = (cents,c) => NF({style:'currency',currency:c}).format(cents/100);
  const redondo = cents => NF({
    style: 'currency', currency: 'EUR',
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2, maximumFractionDigits: 2,
  }).format(cents / 100);
  const COPY = {
    // {u} = "cajas", o en el césped "m de rollo" (data-unit-plural): los rollos son de 2 m de ancho.
    m2: { question: '¿Cuántos m² necesitas?', input_unit: 'm²', real_unit: 'm²', sub_with: '{n} {u} con {pct}% merma', sub_no_waste: '{n} {u}', qty_label: 'cajas' },
    ml: { question: '¿Cuántos metros lineales necesitas?', input_unit: 'm', real_unit: 'ml', sub_with: '{n} piezas', sub_no_waste: '{n} piezas', qty_label: 'piezas' },
  };
  class FC extends HTMLElement {
    connectedCallback() {
      const d = this.dataset;
      this.cfg = {
        mode: d.mode, unitSize: +d.unitSize, priceCents: +d.priceCents,
        taxPct: +d.taxPct, taxesIncluded: d.taxesIncluded === 'true', currency: d.currency, variantId: +d.variantId,
        available: d.available === 'true', soldOutLabel: d.soldOutLabel, formId: d.formId,
        unitPlural: d.unitPlural || 'cajas', unitType: d.unitType,
        boxSize: d.mode === 'ml' ? Math.max(1, +d.boxSize || 1) : 1,
      };
      this.copy = COPY[this.cfg.mode];
      this.maxWastePct = 15;
      this.wastePct = 0;
      const $ = s => this.querySelector(s);
      this.$question = $('[data-role="question"]');
      this.$unit = $('[data-role="unit"]');
      this.$input = $('.mp-calc__input');
      this.$total = $('[data-role="total"]');
      this.$sub = $('[data-role="sub"]');
      this.$envio = $('[data-role="envio"]');
      this.$cta = $('[data-role="cta"]');
      this.$wasteOpen = $('[data-role="waste-open"]');
      this.$wasteEdit = $('[data-role="waste-edit"]');
      this.$wasteInput = $('[data-role="waste-input"]');
      this.$wasteClose = $('[data-role="waste-close"]');
      this.$wasteWarning = $('[data-role="waste-warning"]');
      this.$question.textContent = this.copy.question;
      this.$unit.textContent = this.copy.input_unit;
      this.$input.addEventListener('input', () => this.recompute());
      this.$cta.addEventListener('click', e => this.add(e));
      if (this.$wasteOpen) {
        this.$wasteOpen.addEventListener('click', () => this.openWaste());
        this.$wasteClose.addEventListener('click', () => this.closeWaste());
        this.$wasteInput.addEventListener('input', () => {
          let value = parse(this.$wasteInput.value);
          value = Number.isFinite(value) ? value : 0;

          if (value > this.maxWastePct) {
            value = this.maxWastePct;
            this.$wasteInput.value = String(this.maxWastePct);
            this.$wasteWarning.hidden = false;
          } else {
            this.$wasteWarning.hidden = true;
          }

          this.wastePct = Math.max(0, value);
          this.recompute();
        });
      }
      this.trams = (d.trams || '').split(',')
        .filter(t => t.trim())
        .map(t => t.split(':').map(Number))
        .filter(t => t.length === 2 && t.every(n => Number.isFinite(n) && n >= 0));
      this.cartShippable = this.cartShippable ?? 0;
      this.onCartChange = event => {
        const cart = event.detail && event.detail.cart;
        if (!cart) return;
        this._cartChanged = true;
        this.updateCart(cart);
      };
      document.addEventListener('cart:change', this.onCartChange);
      if (!this._cartRequested) {
        this._cartRequested = true;
        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`)
          .then(response => {
            if (!response.ok) throw new Error('cart.js');
            return response.json();
          })
          .then(cart => {
            // Un cambio de carrito más reciente tiene prioridad sobre la carga inicial.
            if (!this._cartChanged) this.updateCart(cart);
          })
          .catch(() => {});
      }
    }
    updateVariant(data) {
      Object.assign(this.dataset, data);
      Object.assign(this.cfg, {
        mode: data.mode, unitSize: Number(data.unitSize), boxSize: data.mode === 'ml' ? Math.max(1, Number(data.boxSize) || 1) : 1,
        variantId: Number(data.variantId), priceCents: Number(data.priceCents), available: data.available === 'true', soldOutLabel: data.soldOutLabel,
        unitType: data.unitType, unitPlural: data.unitPlural,
      });
      this.copy = COPY[this.cfg.mode];
      this.$question.textContent = this.copy.question;
      this.$unit.textContent = this.copy.input_unit;
      this.variantRatio = 1;
      if (this.currentCart) this.updateCart(this.currentCart);
      else this.recompute();
    }
    disconnectedCallback() {
      document.removeEventListener('cart:change', this.onCartChange);
    }
    updateCart(cart) {
      this.currentCart = cart;
      // Sin las líneas de esta variante: lo que hay en la calculadora ya es ese pedido, si no
      // al añadirlo al carrito se contaría dos veces y saldría «Envío gratis» sin serlo.
      // Su descuento de línea, si lo tiene, se aplica al importe de la calculadora (variantRatio).
      const lines = (cart.items || []).filter(item => item.requires_shipping);
      const own = lines.filter(item => item.variant_id === this.cfg.variantId);
      const items = lines
        .filter(item => item.variant_id !== this.cfg.variantId)
        .reduce((sum, item) => sum + item.final_line_price, 0);
      const ownOriginal = own.reduce((sum, item) => sum + item.original_line_price, 0);
      const ownFinal = own.reduce((sum, item) => sum + item.final_line_price, 0);
      this.variantRatio = ownOriginal > 0 ? ownFinal / ownOriginal : 1;
      const discount = (cart.cart_level_discount_applications || [])
        .reduce((sum, d) => sum + d.total_allocated_amount, 0);
      this.cartShippable = items - discount;
      if (this.isConnected) this.recompute();
    }
    openWaste() {
      this.wastePct = 8; this.$wasteInput.value = 8;
      this.$wasteOpen.hidden = true; this.$wasteEdit.hidden = false;
      this.$wasteWarning.hidden = true;
      this.$wasteInput.focus(); this.$wasteInput.select();
      this.recompute();
    }
    closeWaste() {
      this.wastePct = 0;
      this.$wasteEdit.hidden = true; this.$wasteOpen.hidden = false;
      this.$wasteWarning.hidden = true;
      this.$wasteOpen.focus();
      this.recompute();
    }
    recompute() {
      const input = parse(this.$input.value);
      if (!isFinite(input) || input <= 0) {
        this.$total.hidden=true; this.$sub.hidden=true; this.$cta.disabled=true;
        this.$envio.hidden = true;
        if (!this.cfg.available) this.$cta.textContent = this.cfg.soldOutLabel;
        this.dispatchEvent(new CustomEvent('mp:calc', { bubbles: true, detail: { m2: 0 } }));
        return;
      }
      this.$total.hidden = false;
      const pieces = Math.ceil(input * (1 + this.wastePct/100) / this.cfg.unitSize - 1e-9);
      const qty = Math.ceil(pieces / this.cfg.boxSize) * this.cfg.boxSize;
      const cents = qty * this.cfg.priceCents;
      const centsTax = Math.round(cents * (100 + this.cfg.taxPct) / 100);
      const isPro = this.cfg.taxPct <= 0 && !this.cfg.taxesIncluded;
      const grossPrimary = window.mpPriceMode === 'gross';
      this.$total.textContent = `${cur(grossPrimary ? centsTax : cents, this.cfg.currency)} ${grossPrimary || this.cfg.taxesIncluded ? 'IVA incl.' : '+ IVA'}`;
      this.$sub.hidden = false;
      const tmpl = this.wastePct > 0 ? this.copy.sub_with : this.copy.sub_no_waste;
      const isPack = this.cfg.mode === 'm2' && this.cfg.unitType === 'pack';
      const packText = `${qty} pack${qty === 1 ? '' : 's'} A+B`;
      const qtyText = isPack
        ? `${packText} (${qty * 2} cajas)${this.wastePct > 0 ? ` con ${this.wastePct}% merma` : ''}`
        : this.cfg.boxSize > 1
        ? `${qty / this.cfg.boxSize} caja${qty / this.cfg.boxSize > 1 ? 's' : ''} · ${qty} tiras`
        : tmpl.replace('{n}', qty).replace('{pct}', this.wastePct).replace('{u}', this.cfg.unitPlural)
          // «1 caja», «1 pieza»: singular con una sola unidad.
          .replace(qty === 1 ? /\b(caja|pieza|rollo)s\b/ : /$^/, '$1');
      // m² o ml que recibirá realmente: unidades enteras × contenido por unidad
      const realQty = NF({ minimumFractionDigits: isPack ? 2 : 0, maximumFractionDigits: 2 }).format(qty * this.cfg.unitSize);
      const netText = isPro || this.cfg.taxesIncluded ? '' : grossPrimary ? `(${cur(cents, this.cfg.currency)} + IVA) · ` : `${cur(centsTax, this.cfg.currency)} IVA incl. · `;
      // Rodapiés por caja: decir claramente que se redondea a cajas completas (con 1 ml, 1 caja entera).
      const boxes = qty / this.cfg.boxSize;
      const requestedTxt = NF({ maximumFractionDigits: 2 }).format(input);
      const boxNote = this.cfg.boxSize > 1
        ? (input < this.cfg.boxSize * this.cfg.unitSize - 1e-9
          ? `Se vende por cajas completas: para ${requestedTxt} ml te enviamos `
          : (qty * this.cfg.unitSize > input * (1 + this.wastePct/100) + 1e-9 ? 'Redondeado a cajas completas: ' : ''))
        : '';
      this.$sub.textContent = isPack
        ? `${netText}${qtyText} · ${realQty} m² reales`
        : `${netText}${boxNote}${qtyText} (${realQty} ${this.copy.real_unit} reales)`;
      this.$envio.hidden = !this.cfg.available || !this.trams.length || isPro || this.cfg.taxesIncluded || !Number.isFinite(cents);
      if (!this.$envio.hidden) {
        const order = Math.round(cents * (this.variantRatio ?? 1)) + this.cartShippable;
        const i = this.trams.findIndex(([hasta]) => order <= hasta);
        // Gratis a partir del céntimo siguiente al último tramo (500,01 €): lo que falta, como el carrito.
        const faltan = this.trams[this.trams.length - 1][0] + 1 - order;
        this.$envio.innerHTML = i === -1
          ? '<strong>Envío gratis</strong> a península'
          : `Envío a península: <strong>${redondo(grossPrimary ? Math.round(this.trams[i][1] * (100 + this.cfg.taxPct) / 100) : this.trams[i][1])}&nbsp;${grossPrimary ? 'IVA incl.' : '+ IVA'}</strong> · te faltan ${NF({ style: 'currency', currency: 'EUR' }).format((grossPrimary ? Math.round(faltan * (100 + this.cfg.taxPct) / 100) : faltan) / 100).replace(/\s/g, '\u00a0')} para que sea gratis`;
      }
      this.$cta.disabled = !this.cfg.available;
      this.$cta.textContent = !this.cfg.available
        ? this.cfg.soldOutLabel
        : isPack ? `Añadir ${packText}`
        : this.cfg.boxSize > 1
          ? `Añadir ${boxes} caja${boxes > 1 ? 's' : ''} (${qty} tiras) al carrito`
          : 'Añadir al carrito';
      this._calc = { qty, input, pct: this.wastePct };
      // Venta cruzada: m² reales que recibirá (unidades enteras × m² por caja), para calcular base y rodapié
      if (this.cfg.mode === 'm2') this.dispatchEvent(new CustomEvent('mp:calc', { bubbles: true, detail: { m2: qty * this.cfg.unitSize } }));
    }
    lineProperties(input, qty, pct) {
      const props = {
        [`_${this.cfg.mode}_solicitados`]: NF({maximumFractionDigits:2}).format(input),
        [this.cfg.mode === 'ml' ? '_piezas' : '_cajas']: String(qty),
      };
      if (this.cfg.mode === 'ml' && this.cfg.boxSize > 1) props._cajas = String(qty / this.cfg.boxSize);
      if (pct > 0) props._merma_pct = String(pct);
      return window.MPLineQuantity ? window.MPLineQuantity.properties(props, qty, this.cfg) : props;
    }
    addHiddenInput(form, name, value) {
      const field = document.createElement('input');
      field.type = 'hidden';
      field.name = name;
      field.value = value;
      field.setAttribute('data-mp-calc', '');
      form.append(field);
    }
    submitNativeForm(form, props, qty) {
      form.querySelectorAll('[data-mp-calc]').forEach(input => input.remove());
      Object.entries(props).forEach(([name, value]) => this.addHiddenInput(form, `properties[${name}]`, value));
      const qtyInput = form.querySelector('input[name="quantity"]') || document.querySelector(`[name="quantity"][form="${this.cfg.formId}"]`);
      if (qtyInput) {
        qtyInput.value = qty;
      } else {
        // Esta plantilla PDP no lleva quantity_selector: sin este campo Shopify asumiría 1.
        // Lo inyectamos y lo limpiamos en cada envío mediante data-mp-calc.
        this.addHiddenInput(form, 'quantity', qty);
      }

      if (!form.checkValidity()) {
        form.reportValidity();
        this.$cta.disabled = false;
        this.$cta.textContent = 'Reintentar';
        return;
      }

      let guard;
      const cleanup = () => {
        clearTimeout(guard);
        form.removeEventListener('variant:add', finish);
        form.removeEventListener('cart:error', fail);
      };
      const finish = () => {
        cleanup();
        this.$cta.textContent = 'Añadido';
        setTimeout(() => this.recompute(), 1500);
      };
      const fail = () => {
        cleanup();
        this.$cta.disabled = false;
        this.$cta.textContent = 'Reintentar';
      };

      form.addEventListener('variant:add', finish, { once: true });
      form.addEventListener('cart:error', fail, { once: true });
      guard = setTimeout(() => { if (this.$cta.textContent === 'Añadiendo…') fail(); }, 6000);
      try {
        form.requestSubmit();
      } catch (error) {
        cleanup();
        throw error;
      }
    }
    async add(e) {
      e.preventDefault();
      if (!this.cfg.available || !this._calc) return;
      const { qty, input, pct } = this._calc;
      const props = this.lineProperties(input, qty, pct);
      this.$cta.disabled = true; this.$cta.textContent = 'Añadiendo…';
      try {
        const form = document.getElementById(this.cfg.formId);
        if (form) {
          this.submitNativeForm(form, props, qty);
          return;
        }

        const res = await fetch('/cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
          body: JSON.stringify({
            items:[{id:this.cfg.variantId, quantity:qty, properties:props}],
            sections:'cart-drawer,cart-icon-bubble',
          }),
        });
        if (!res.ok) throw 0;
        document.documentElement.dispatchEvent(new CustomEvent('mp:cart-add-success', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        this.$cta.textContent = 'Añadido';
        setTimeout(() => this.recompute(), 1500);
      } catch {
        this.$cta.disabled = false; this.$cta.textContent = 'Reintentar';
      }
    }
  }
  customElements.define('flooring-calculator', FC);
})();
